import { getClosestConfigurationFromSector } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import {
    TEXT_ANCHOR_END, TEXT_ANCHOR_MIDDLE,
    TEXT_ANCHOR_START,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import getYOffsetFromSeat from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getYOffsetForSeat';

function mergeLabel(sector, compiledLabel) {
    sector.label = {
        ...sector.label,
        compiled: {
            ...compiledLabel,
        },
        transformation: {
            rotation: -sector.transformation.rotation,
        },
    };

    return sector;
}

function compileSectorLabel(sector) {
    const configuration = getClosestConfigurationFromSector(sector, 'fontConfig');
    const { seatConfig } = getClosestConfigurationFromSector(sector, 'seatConfig');
    const {
        label: { text, textAnchor, manual },
        compiled: { polygon: { dimensions: { width } } },
    } = sector;

    if (text === null) {
        return sector;
    }

    const compiledLabel = {
        ...sector.label.compiled,
        size: configuration.fontConfig.size.sector,
        family: configuration.fontConfig.family,
        color: configuration.fontConfig.color,
    };

    if (manual) {
        return mergeLabel(sector, compiledLabel);
    }

    if (textAnchor === TEXT_ANCHOR_START) {
        compiledLabel.x = 0;
    }
    if (textAnchor === TEXT_ANCHOR_END) {
        compiledLabel.x = width;
    }
    if (textAnchor === TEXT_ANCHOR_MIDDLE) {
        compiledLabel.x = width / 2;
    }
    compiledLabel.y = getYOffsetFromSeat(seatConfig);
    compiledLabel.text = { ...compiledLabel.text, x: compiledLabel.x, y: compiledLabel.y };

    return mergeLabel(sector, compiledLabel);
}

export default compileSectorLabel;
